export default "__VITE_ASSET__B1QI3BUe__"